import React from "react";
import { SimpleGrid, Title } from "@mantine/core";
import CustomTextInput from "../../ui/CustomTextInput/CustomTextInput";
import CustomButton from "../../ui/CustomButton/CustomButton";

const CompanyLogoSection = ({ logoBase64, onUploadClick }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <h2 className="text-base sm:text-lg font-bold text-gray-900">
          Company Logo
        </h2>

        <CustomButton
          radius="xl"
          variant="outline"
          size="sm"
          onClick={onUploadClick}
        >
          {logoBase64 ? "Update Logo" : "Upload Logo"}
        </CustomButton>
      </div>

      {logoBase64 ? (
        <img
          src={`${logoBase64}`}
          alt="Company Logo"
          className="w-20 h-20 sm:w-32 sm:h-32 object-contain border-[2px] border-primary-600 rounded-full"
        />
      ) : (
        <p className="text-xs sm:text-sm text-gray-500">No logo uploaded.</p>
      )}
    </div>
  );
};

const CompanyInfoSection = ({ merchantProfile }) => {
  return (
    <div>
      <Title order={4} className="text-sm sm:text-xl text-gray-900 mb-4">
        Company Information
      </Title>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mb="md">
        <CustomTextInput
          label="Merchant Name"
          value={merchantProfile?.merchantName || "-"}
          readOnly
          radius="xl"
          variant="filled"
        />
        <CustomTextInput
          label="Merchant ID"
          value={merchantProfile?.merchantId || "-"}
          readOnly
          radius="xl"
          variant="filled"
        />
      </SimpleGrid>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mb="md">
        <CustomTextInput
          label="Wallet Account"
          value={merchantProfile?.walletAccount || "-"}
          readOnly
          radius="xl"
          variant="filled"
        />
        <CustomTextInput
          label="Wallet Balance"
          value={`KES ${
            merchantProfile?.walletBalance?.toLocaleString() || "0.00"
          }`}
          readOnly
          radius="xl"
          variant="filled"
        />
      </SimpleGrid>
    </div>
  );
};

const ContactPhoneSection = ({ contactPhoneNumbers }) => {
  return (
    <div>
      <Title order={4} className="text-gray-900 mb-4">
        Contact Phone Numbers
      </Title>
      {contactPhoneNumbers?.length ? (
        contactPhoneNumbers.map((contact) => (
          <div
            key={contact.id}
            className="mb-3 border p-3 rounded-lg bg-gray-50"
          >
            <p className="text-sm font-semibold text-gray-700">
              {contact.phoneNumber}
            </p>
            <p className="text-xs text-gray-500">{contact.description}</p>
            {contact.defaultSmsRecipient && (
              <span className="text-xs text-green-600 font-medium">
                Default SMS Recipient
              </span>
            )}
          </div>
        ))
      ) : (
        <p className="text-sm text-gray-500">No contact numbers available.</p>
      )}
    </div>
  );
};

export { CompanyLogoSection, CompanyInfoSection, ContactPhoneSection };
